import React, { useEffect, useState } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import { connect } from "react-redux";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import AssessmentIcon from "@material-ui/icons/Assessment";
import Tooltip from "@material-ui/core/Tooltip";
import { getInventoryDashboardRecords } from "../helper/dashboardHelper";
import { getSessionData } from "../../base/helper/baseHelper";
import { useHistory } from "react-router-dom";
import { Grid } from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import SelectableSearch from "../../base/views/SelectableSearch";
import { getSuppliers } from "../../Ancillary/SupplierManagement/helper/supplierManagementHelper";
import { subDays } from "date-fns";

function RecentCapturedGoodsDashboard(props) {
  const [userId, setUserId] = useState("");
  const [fromDate, setFromDate] = useState(subDays(new Date(), 1));
  const [toDate, setToDate] = useState(new Date());
  const [storeId, setStoreId] = useState("");
  const [suppliers, setSuppliers] = useState({ load: false, values: [] });
  const [supplier, setSupplier] = useState({ id: 0, optionname: "" });
  const [gridData, setGridData] = React.useState([]);
  const history = useHistory();

  const loadDashboard = (user_id, store_id, fromDate, toDate, supplierId) => {
    if (user_id !== "" && store_id !== "" && supplierId) {
      getInventoryDashboardRecords(
        user_id,
        store_id,
        fromDate,
        toDate,
        supplierId
      )
        .then((response) => {
          if (response) {
            setGridData(response);
          }
        })
        .catch((err) => {});
    }
  };

  const loadSuppliers = async () => {
    try {
      setSuppliers((prev) => ({ ...prev, load: true }));
      const { hasError, data } = await getSuppliers(storeId);
      if (!hasError)
        setSuppliers((prev) => ({
          ...prev,
          values: data.map((option) => ({
            id: option.supplier_id,
            optionname: option.name,
          })),
        }));
    } catch (error) {
      //
    } finally {
      setSuppliers((prev) => ({ ...prev, load: false }));
    }
  };

  useEffect(() => {
    setUserId(getSessionData({ key: "userId" }));
    const store = JSON.parse(getSessionData({ key: "store" }));
    setStoreId(store.storeid);
    loadDashboard(userId, storeId, fromDate, toDate, supplier.id);
    // eslint-disable-next-line
  }, [userId, storeId, fromDate, toDate, supplier]);

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <>
      <Grid
        container
        direction="row"
        item
        xs={12}
        style={{
          width: "100%",
          marginTop: "0.25rem",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Grid item xs={3} md={3}>
          <SelectableSearch
            value={supplier}
            data={suppliers}
            name={"supplier"}
            label={"Supplier"}
            id={"recentgoodscaptured-supplier"}
            loading={loadSuppliers}
            onChangeEvent={(e, val) => {
              setSupplier(val);
            }}
          />
        </Grid>
        <Grid item xs={3} md={3}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              autoFocus
              margin="normal"
              autoOk={true}
              id="year"
              label="From Date"
              format="yyyy-MM-dd"
              value={fromDate}
              onChange={setFromDate}
              okLabel={""}
              cancelLabel={""}
              views={["year", "month", "date"]}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={3} md={3}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              margin="normal"
              autoOk={true}
              id="year"
              label="To Date"
              format="yyyy-MM-dd"
              value={toDate}
              onChange={setToDate}
              okLabel={""}
              cancelLabel={""}
              views={["year", "month", "date"]}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
            />
          </MuiPickersUtilsProvider>
        </Grid>
      </Grid>

      <MaterialTable
        title="Goods Receivable"
        columns={[
          {
            title: "Invoice Date",
            field: "loaddate",
            type: "date",
            render: (row) => new Date(row.loaddate).toLocaleDateString("en-US"),
            defaultSort: "asc",
          },
          { title: "Supplier", field: "supplier" },
          { title: "Tote #", field: "toteno" },
          { title: "Items Scanned", field: "itemsscanned" },
        ]}
        data={gridData}
        onRowClick={(e, rowData) => {
          history.push(
            `/reports/recentCapturedGoodsReport?f_date=${fromDate}&t_date=${toDate}&supplierId=${supplier.id}&supplier=${supplier.optionname}&tote=${rowData.toteno}&showBack=true`
          );
        }}
        components={{
          Toolbar: (props) => (
            <Box display="flex">
              <Box flexGrow={1}>
                <MTableToolbar {...props} />
              </Box>
              <Box paddingBottom={1.5} paddingTop={2}>
                <Tooltip title="Generate Report">
                  <IconButton
                    color="secondary"
                    size="medium"
                    onClick={() =>
                      history.push("/reports/recentCapturedGoodsReport")
                    }
                  >
                    <AssessmentIcon fontSize="inherit" />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
          ),
        }}
        options={{
          maxBodyHeight: 415,
          pageSize: 10,
          pageSizeOptions: [10],
          headerStyle: {
            backgroundColor: "rgba(255,255,255,1)",
            color: "black",
          },
        }}
      />
    </>
  );
}

const mapStateToDispatch = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToDispatch,
  mapDispatchToProps
)(RecentCapturedGoodsDashboard);
